import dayjs from 'dayjs';

import { dateFormatLongYear } from '../../../../constants/dates';

export const getDate = (date: Date): string => {
  return dayjs(date).format(dateFormatLongYear);
};

export const stringToDateFormat = (date: string, format: string = dateFormatLongYear): Date => {
  return dayjs(date, { format: format }).toDate();
};
